// extracted by mini-css-extract-plugin
module.exports = {"item":"VideoGridItem_item__2P63g"};